import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ssoLoginSuccess } from '../../redux/UserSlice';

const AuthSuccess = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const name = params.get('name');
    const email = params.get('email');
    const role = params.get('role');

    if (token && email) {
      dispatch(
        ssoLoginSuccess({
          message: 'User logged in successfully',
          success: true,
          token,
          name,
          email,
          role,
        })
      );
    }

    window.history.replaceState({}, document.title, '/');
    navigate('/', { replace: true });
  }, [dispatch, navigate]);

  return null;
};

export default AuthSuccess;
